<!-- =========================================================================================
  File Name: VerticalNavMenu.vue
  Description: Vertical NavMenu Component
  Component Name: VerticalNavMenu
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
    Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="parentx">

    <vs-sidebar
      class="v-nav-menu items-no-padding"
      v-model="isVerticalNavMenuActive"
      ref="verticalNavMenu"
      default-index="-1"
      :click-not-close="clickNotClose"
      :reduce-not-rebound="reduceNotRebound"
      :parent="parent"
      :hiddenBackground="clickNotClose"
      :reduce="reduce"
      v-hammer:swipe="onMenuSwipe">

      <div @mouseenter="mouseEnter" @mouseleave="mouseLeave">

        <!-- Header -->
        <div class="header-sidebar flex items-end justify-between" slot="header">

          <!-- Logo -->
          <router-link tag="div" class="vx-logo cursor-pointer flex items-center" to="/">
            <logo class="w-10 mr-4 fill-current text-primary" />
            <span class="vx-logo-text text-primary" v-show="isMouseEnter || !reduce" v-if="title">{{ title }}</span>
          </router-link>
          <!-- /Logo -->

          <!-- Menu Buttons -->
          <div>
            <!-- Close Button -->
            <template v-if="showCloseButton">
              <feather-icon icon="XIcon" class="m-0 cursor-pointer" @click="$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', false)" />
            </template>

            <!-- Toggle Buttons -->
            <template v-else-if="!showCloseButton && !verticalNavMenuItemsMin">
              <feather-icon
                id="btnVNavMenuMinToggler"
                class="mr-0 cursor-pointer"
                :icon="reduce ? 'CircleIcon' : 'DiscIcon'"
                svg-classes="stroke-current text-primary"
                @click="toggleReduce(!reduce)" />
            </template>
          </div>
          <!-- /Menu Toggle Buttons -->
        </div>
        <!-- /Header -->

        <!-- Header Shadow -->
        <div class="shadow-bottom" v-show="showShadowBottom" />

        <!-- Menu Items -->
        <component :is="scrollbarTag" ref="verticalNavMenuPs" class="scroll-area-v-nav-menu pt-2" :settings="settings" @ps-scroll-y="psSectionScroll" @scroll="psSectionScroll" :key="$vs.rtl">
          <v-nav-menu-item
            index="1"
            :to="staffRoute ? {name: 'dashboard'} : {name: 'companies-dashboard', params: {slug: $route.params.slug}} "
            icon="HomeIcon"
            slug="companies-menu">
              <span class="truncate">Dashboard</span>
          </v-nav-menu-item>

          <v-nav-menu-item
            index="2"
            :to="{name: 'orders'}"
            icon="ShoppingCartIcon"
            slug="orders"
            v-if="staffRoute">
              <span class="truncate">Bestellingen</span>
          </v-nav-menu-item>

          <v-nav-menu-item
            index="2"
            :to="{name: 'invoices'}"
            icon="FileTextIcon"
            slug="orders"
            v-if="staffRoute && viewInvoices">
              <span class="truncate">Facturen</span>
          </v-nav-menu-item>

          <span
            class="navigation-header truncate"
            v-if="staffRoute">
            Bedrijven
          </span>

          <v-nav-menu-item
            index="2"
            :to="{name: 'companies-list'}"
            icon="HomeIcon"
            slug="companies-menu"
            v-if="staffRoute">
              <span class="truncate">Overzicht</span>
          </v-nav-menu-item>
          <v-nav-menu-item
                  index="3"
                  :to="{name: 'company-categories'}"
                  icon="PlusIcon"
                  slug="company-categories"
                  v-if="staffRoute">
            <span class="truncate">Categorieën</span>
          </v-nav-menu-item>
          <v-nav-menu-item
                  index="2"
                  :to="{name: 'global-invoiceables'}"
                  icon="DollarSignIcon"
                  slug="companies-menu"
                  v-if="staffRoute">
            <span class="truncate">Te factureren</span>
          </v-nav-menu-item>
          <transition v-if="$route.params.slug !== undefined">
            <v-nav-menu-item
                    index="2"
                    :to="{name: 'companies-dashboard'}"
                    icon="HardDriveIcon"
                    slug="companies-menu"
                    v-if="staffRoute">
              <span class="truncate">Dashboard</span>
            </v-nav-menu-item>
          </transition>

          <transition v-if="$route.params.slug !== undefined">
            <v-nav-menu-item
                  index="2"
                  :to="{name: 'company-contacts'}"
                  icon="AtSignIcon"
                  slug="companies-menu"
                  >
            <span class="truncate">Contacten</span>
            </v-nav-menu-item>
          </transition>

          <transition v-if="$route.params.slug !== undefined">
            <v-nav-menu-item
                    index="2"
                    :to="{name: 'companies-delivery-locations-and-fees'}"
                    icon="MapPinIcon"
                    slug="companies-menu"
            >
              <span class="truncate">Bezorglocaties</span>
            </v-nav-menu-item>
          </transition>

          <transition v-if="$route.params.slug !== undefined">
            <v-nav-menu-item
              index="3"
              :to="{name: 'companies-menu', params: {slug: $route.params.slug}}"
              icon="BookOpenIcon"
              slug="companies-menu">
                <span class="truncate">Menu</span>
            </v-nav-menu-item>
          </transition>


          <transition v-if="$route.params.slug !== undefined">
            <v-nav-menu-group
              :openHover="true"
              :group="productsGroup"
              :groupIndex="1"
              :open="isGroupActive(productsGroup)" />
          </transition>

          <transition v-if="$route.params.slug !== undefined">
            <v-nav-menu-item
              index="4"
              :to="{name: 'companies-orders', params: {slug: $route.params.slug}}"
              icon="ClipboardIcon"
              slug="companies-orders">
                <span class="truncate">Bestellingen</span>
            </v-nav-menu-item>
          </transition>

          <transition v-if="$route.params.slug !== undefined && viewInvoices">
            <v-nav-menu-item
              index="4"
              :to="{name: 'companies-invoices', params: {slug: $route.params.slug}}"
              icon="FileTextIcon"
              slug="companies-invoices">
                <span class="truncate">Facturen</span>
            </v-nav-menu-item>
          </transition>

          <transition v-if="$route.params.slug !== undefined">
            <v-nav-menu-item
              index="5"
              :to="{name: 'companies-reviews', params: {slug: $route.params.slug}}"
              icon="StarIcon"
              slug="companies-reviews">
                <span class="truncate">Beoordelingen</span>
            </v-nav-menu-item>
          </transition>

          <transition v-if="$route.params.slug !== undefined">
            <v-nav-menu-item
                    index="5"
                    :to="{name: 'company-coupons', params: {slug: $route.params.slug}}"
                    icon="DollarSignIcon"
                    slug="companies-reviews">
              <span class="truncate">Kortingscodes</span>
            </v-nav-menu-item>
          </transition>

          <transition v-if="$route.params.slug !== undefined">
            <v-nav-menu-item
              index="5"
              :to="{name: 'companies-settings', params: {slug: $route.params.slug}}"
              icon="SettingsIcon"
              slug="companies-orders">
                <span class="truncate">Instellingen</span>
            </v-nav-menu-item>
          </transition>

          <span
            class="navigation-header truncate"
            v-if="staffRoute">
            Bezorgservice
          </span>

          <v-nav-menu-item
            index="1"
            :to="{name: 'delivery-overview'}"
            icon="MapIcon"
            slug="delivery-overview"
            v-if="staffRoute">
              <span class="truncate">Overzicht</span>
          </v-nav-menu-item>

          <v-nav-menu-item
            index="2"
            :to="{name: 'deliverer-overview'}"
            icon="UserIcon"
            slug="deliverer-overview"
            v-if="staffRoute">
              <span class="truncate">Bezorgers</span>
          </v-nav-menu-item>

          <v-nav-menu-item
            index="3"
            :to="{name: 'delivery-agenda'}"
            icon="CalendarIcon"
            slug="deliverer-agenda"
            v-if="staffRoute">
              <span class="truncate">Agenda</span>
          </v-nav-menu-item>
          <v-nav-menu-item
            index="4"
            :to="{name: 'vehicles'}"
            icon="TruckIcon"
            slug="vehicles"
            v-if="staffRoute">
              <span class="truncate">Middelen</span>
          </v-nav-menu-item>

          <v-nav-menu-item
              index="4"
              :to="{name: 'delivery-locations'}"
              icon="MapPinIcon"
              slug="vehicles"
              v-if="staffRoute">
            <span class="truncate">Bezorglocaties</span>
          </v-nav-menu-item>

          <span
            class="navigation-header truncate"
            v-if="staffRoute">
            Medewerkers
          </span>

          <v-nav-menu-item
            index="1"
            :to="{name: 'staff-list'}"
            icon="UsersIcon"
            slug="staff"
            v-if="staffRoute">
              <span class="truncate">Overzicht</span>
          </v-nav-menu-item>

          <v-nav-menu-item
            index="2"
            :to="{name: 'agenda'}"
            icon="CalendarIcon"
            slug="agenda"
            v-if="staffRoute">
              <span class="truncate">Agenda</span>
          </v-nav-menu-item>
          <v-nav-menu-item
                  index="3"
                  :to="{name: 'permissions'}"
                  icon="AlertCircleIcon"
                  slug="permissions"
                  v-if="staffRoute">
            <span class="truncate">Permissies</span>
          </v-nav-menu-item>
          <v-nav-menu-item
                  index="3"
                  :to="{name: 'roles'}"
                  icon="BriefcaseIcon"
                  slug="roles"
                  v-if="staffRoute">
            <span class="truncate">Rollen</span>
          </v-nav-menu-item>

        </component>
        <!-- /Menu Items -->
      </div>
    </vs-sidebar>

    <!-- Swipe Gesture -->
    <div
      v-if="!isVerticalNavMenuActive"
      class="v-nav-menu-swipe-area"
      v-hammer:swipe="onSwipeAreaSwipe" />
    <!-- /Swipe Gesture -->
  </div>
</template>


<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import VNavMenuGroup from './VerticalNavMenuGroup.vue'
import VNavMenuItem from './VerticalNavMenuItem.vue'

import Logo from '../Logo.vue'

export default {
  name: 'v-nav-menu',
  components: {
    VNavMenuGroup,
    VNavMenuItem,
    VuePerfectScrollbar,
    Logo
  },
  props: {
    logo:             { type: String },
    openGroupHover:   { type: Boolean, default: false },
    parent:           { type: String },
    reduceNotRebound: { type: Boolean, default: true },
    navMenuItems:     { type: Array,   required: true },
    title:            { type: String }
  },
  data: () => ({
    viewInvoices: false,
    clickNotClose       : false, // disable close navMenu on outside click
    isMouseEnter        : false,
    reduce              : false, // determines if navMenu is reduce - component property
    showCloseButton     : false, // show close button in smaller devices
    settings            : {      // perfectScrollbar settings
      maxScrollbarLength: 60,
      wheelSpeed        : 1,
      swipeEasing       : true
    },
    showShadowBottom    : false,
    productsGroup: {
      url: null,
      name: 'Producten',
      icon: 'ShoppingCartIcon',
      submenu: [
        {
          url: {name: 'companies-products'},
          name: 'Overzicht',
          slug: 'companies-products'
        },
        {
          url: {name: 'companies-product-categories'},
          name: 'Categorieën',
          slug: 'companies-product-categories'
        },
        {
          url: {name: 'companies-products-option-categories'},
          name: 'Optie categorieën',
          slug: 'companies-products-option-categories'
        },
        {
          url: {name: 'companies-products-options'},
          name: 'Opties',
          slug: 'companies-products-options'
        },
      ]
    },
  }),
  computed: {
    staffRoute () {
      if(this.$route.meta.staff) {
        if(localStorage.getItem('stafftoken') !== null) {
          return true
        }
      } else {
        if(localStorage.getItem('stafftoken') !== null) {
          return true
        }
        return false
      }
    },
    isGroupActive () {
      return (item) => {
        const path        = this.$route.fullPath
        const routeParent = this.$route.meta ? this.$route.meta.parent : undefined
        let open          = false

        const func = (item) => {
          if (item.submenu) {
            item.submenu.forEach((item) => {
              if (item.url && (path === item.url || routeParent === item.slug)) { open = true } else if (item.submenu) { func(item) }
            })
          }
        }
        func(item)
        return open
      }
    },
    menuItemsUpdated () {
      const clone = this.navMenuItems.slice()

      for (const [index, item] of this.navMenuItems.entries()) {
        if (item.header && item.items.length && (index || 1)) {
          const i = clone.findIndex(ix => ix.header === item.header)
          for (const [subIndex, subItem] of item.items.entries()) {
            if(subItem.url.includes(':slug')) {
              subItem.url = subItem.url.replace(':slug', this.$route.params.slug);
              clone.splice(i + 1 + subIndex, 0, subItem)
            } else {
              clone.splice(i + 1 + subIndex, 0, subItem)
            }
          }
        }
      }

      return clone
    },
    isVerticalNavMenuActive: {
      get ()    { return this.$store.state.isVerticalNavMenuActive },
      set (val) { this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', val) }
    },
    layoutType () { return this.$store.state.mainLayoutType },
    reduceButton: {
      get ()    { return this.$store.state.reduceButton },
      set (val) { this.$store.commit('TOGGLE_REDUCE_BUTTON', val) }
    },
    isVerticalNavMenuReduced () { return Boolean(this.reduce && this.reduceButton) },
    verticalNavMenuItemsMin ()  { return this.$store.state.verticalNavMenuItemsMin },
    scrollbarTag ()             { return this.$store.getters.scrollbarTag          },
    windowWidth ()              { return this.$store.state.windowWidth             }
  },
  watch: {
    '$route' () {
      if (this.isVerticalNavMenuActive && this.showCloseButton) this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', false)
    },
    reduce (val) {
      const verticalNavMenuWidth = val ? 'reduced' : this.$store.state.windowWidth < 1200 ? 'no-nav-menu' : 'default'
      this.$store.dispatch('updateVerticalNavMenuWidth', verticalNavMenuWidth)

      setTimeout(function () {
        window.dispatchEvent(new Event('resize'))
      }, 100)
    },
    layoutType ()   { this.setVerticalNavMenuWidth() },
    reduceButton () { this.setVerticalNavMenuWidth() },
    windowWidth ()  { this.setVerticalNavMenuWidth() }
  },
  methods: {
    onMenuSwipe (event) {
      if (event.direction === 4 && this.$vs.rtl) {

        // Swipe Right
        if (this.isVerticalNavMenuActive && this.showCloseButton) this.isVerticalNavMenuActive = false

      } else if (event.direction === 2 && !this.$vs.rtl) {

        // Swipe Left
        if (this.isVerticalNavMenuActive && this.showCloseButton) this.isVerticalNavMenuActive = false
      }
    },
    onSwipeAreaSwipe (event) {

      if (event.direction === 4 && !this.$vs.rtl) {

        // Swipe Right
        if (!this.isVerticalNavMenuActive && this.showCloseButton) this.isVerticalNavMenuActive = true
      } else if (event.direction === 2 && this.$vs.rtl) {

        // Swipe Left
        if (!this.isVerticalNavMenuActive && this.showCloseButton) this.isVerticalNavMenuActive = true
      }
    },
    psSectionScroll () {
      const scroll_el = this.$refs.verticalNavMenuPs.$el || this.$refs.verticalNavMenuPs
      this.showShadowBottom = scroll_el.scrollTop > 0
    },
    mouseEnter () {
      if (this.reduce) this.$store.commit('UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN', false)
      this.isMouseEnter = true
    },
    mouseLeave () {
      if (this.reduce) this.$store.commit('UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN', true)
      this.isMouseEnter = false
    },
    setVerticalNavMenuWidth () {

      if (this.windowWidth > 1200) {
        if (this.layoutType === 'vertical') {

          // Set reduce
          this.reduce = !!this.reduceButton

          // Open NavMenu
          this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', true)

          // Set Menu Items Only Icon Mode
          const verticalNavMenuItemsMin = !!(this.reduceButton && !this.isMouseEnter)
          this.$store.commit('UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN', verticalNavMenuItemsMin)

          // Menu Action buttons
          this.clickNotClose   = true
          this.showCloseButton = false

          const verticalNavMenuWidth   = this.isVerticalNavMenuReduced ? 'reduced' : 'default'
          this.$store.dispatch('updateVerticalNavMenuWidth', verticalNavMenuWidth)

          return
        }
      }

      // Close NavMenu
      this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', false)

      // Reduce button
      if (this.reduceButton) this.reduce = false

      // Menu Action buttons
      this.showCloseButton = true
      this.clickNotClose   = false

      // Update NavMenu Width
      this.$store.dispatch('updateVerticalNavMenuWidth', 'no-nav-menu')

      // Remove Only Icon in Menu
      this.$store.commit('UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN', false)


      // if(this.layoutType === 'vertical' || (this.layoutType === 'horizontal' && this.windowWidth < 1200))
      // if (this.windowWidth < 1200) {

      //   // Close NavMenu
      //   this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', false)

      //   // Reduce button
      //   if (this.reduceButton) this.reduce = false

      //   // Menu Action buttons
      //   this.showCloseButton = true
      //   this.clickNotClose   = false

      //   // Update NavMenu Width
      //   this.$store.dispatch('updateVerticalNavMenuWidth', 'no-nav-menu')

      //   // Remove Only Icon in Menu
      //   this.$store.commit('UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN', false)

      // } else {

      //   // Set reduce
      //   this.reduce = this.reduceButton ? true : false

      //   // Open NavMenu
      //   this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', true)

      //   // Set Menu Items Only Icon Mode
      //   const verticalNavMenuItemsMin = (this.reduceButton && !this.isMouseEnter) ? true : false
      //   this.$store.commit('UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN', verticalNavMenuItemsMin)

      //   // Menu Action buttons
      //   this.clickNotClose   = true
      //   this.showCloseButton = false

      //   const verticalNavMenuWidth   = this.isVerticalNavMenuReduced ? "reduced" : "default"
      //   this.$store.dispatch('updateVerticalNavMenuWidth', verticalNavMenuWidth)
      // }
    },
    toggleReduce (val) {
      this.reduceButton = val
      this.setVerticalNavMenuWidth()
    }
  },
  mounted () {
    this.setVerticalNavMenuWidth()
    setTimeout(
      () => {
        if(this.$can('view-invoices') == true) {
          this.viewInvoices = true;
        }
      }, 2000
    )
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/components/verticalNavMenu.scss"
</style>
